import React, { useState } from 'react';
import './ToolPage.css';

const UrlEncoder = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState('encode');

  const encode = () => {
    try {
      const encoded = encodeURIComponent(input);
      setOutput(encoded);
    } catch (e) {
      setOutput('Error encoding URL');
    }
  };

  const decode = () => {
    try {
      const decoded = decodeURIComponent(input);
      setOutput(decoded);
    } catch (e) {
      setOutput('Error: Invalid URL encoded string');
    }
  };

  const handleConvert = () => {
    if (mode === 'encode') {
      encode();
    } else {
      decode();
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
  };

  const clearAll = () => {
    setInput('');
    setOutput('');
  };

  return (
    <div className="tool-page">
      <div className="tool-header">
        <h1 className="tool-title">URL Encoder/Decoder</h1>
        <p className="tool-description">
          Encode and decode URL strings
        </p>
      </div>

      <div className="tool-content">
        <div className="mode-toggle">
          <button
            className={`mode-btn ${mode === 'encode' ? 'active' : ''}`}
            onClick={() => setMode('encode')}
          >
            Encode
          </button>
          <button
            className={`mode-btn ${mode === 'decode' ? 'active' : ''}`}
            onClick={() => setMode('decode')}
          >
            Decode
          </button>
        </div>

        <div className="textarea-row">
          <div className="textarea-group">
            <label className="input-label">
              {mode === 'encode' ? 'Text to Encode' : 'URL to Decode'}
            </label>
            <textarea
              className="textarea-field"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder={mode === 'encode' ? 'Enter text to encode' : 'Enter URL encoded string to decode'}
              rows={6}
            />
          </div>

          <div className="textarea-group">
            <label className="input-label">Output</label>
            <textarea
              className="textarea-field"
              value={output}
              readOnly
              placeholder="Result will appear here"
              rows={6}
            />
          </div>
        </div>

        <div className="button-row">
          <button className="action-btn primary" onClick={handleConvert}>
            {mode === 'encode' ? 'Encode' : 'Decode'}
          </button>
          <button className="action-btn" onClick={copyOutput} disabled={!output}>
            Copy Output
          </button>
          <button className="clear-btn" onClick={clearAll}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default UrlEncoder;
